import { CONTEST_DATE, CONTEST_DURATION } from '../common/constants';
// import { getContestStatus } from '../data';

type ContestTiming = {
  drift: number;
  contestStart: number;
  contestEnd: number;
};

const timing: ContestTiming = {
  drift: 0,
  contestStart: CONTEST_DATE.getTime(),
  contestEnd: CONTEST_DATE.getTime() + CONTEST_DURATION,
};

export const initContestTiming = async (): Promise<void> => {
  // try {
  // const status = await getContestStatus();
  // const serverTime = new Date(status.server_time).getTime();
  // timing = {
  //   drift: serverTime - Date.now(),
  //   contestStart: new Date(status.contest_start).getTime(),
  //   contestEnd: new Date(status.contest_end).getTime(),
  // };
  // } catch {
  //   // backend unreachable — use local constants as fallback
  // }
};

export const getAdjustedNow = (): number => Date.now() + timing.drift;

export const getContestStart = (): number => timing.contestStart;

export const getContestEnd = (): number => timing.contestEnd;
